export default "__VITE_ASSET__C3GaVB6F__"